import * as React from "react";
function SvgFlag(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M38.5 45.2V1.4c0-.8-.6-1.4-1.4-1.4-.8 0-1.4.6-1.4 1.4v2.3c-3-.6-6-.9-9-.9h-.1c-4.2.1-8.9 2.3-14.2 2.3h-.2c-2.3 0-4.7-.3-6.9-.9v22c2.8.7 5.6 1.1 8.5 1.2 5.2 0 8-3 13-3 3 .1 6 .5 9 1.2v19.5h-4.1V48h11.1v-2.8h-4.3zM26.4 22c-2.4.1-4.7.6-6.9 1.5-1.8.8-3.8 1.2-5.7 1.2-1.9 0-3.8-.3-5.7-.7V7.4c1.4.2 2.8.4 4.2.4h.2c3 0 6-.5 8.9-1.4 1.8-.5 3.6-.9 5.5-1 3 .1 6 .4 9 1v16.4c-3.2-.5-6.4-.8-9.5-.8z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgFlag);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
